import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navber from "../Components/Navber.jsx";
import "../Styles/Activity.css"
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  TextField,
  Slider,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Rating,
  Stack,
  Container,
} from "@mui/material";
import api from "../Api"; // adjust path
import DOMPurify from "dompurify";

const ActivityGrid = () => {
  const [activities, setActivities] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [priceRange, setPriceRange] = useState([0, 50000]);
  const [sortBy, setSortBy] = useState("");
  const [ratings, setRatings] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    fetchActivities();
  }, []);

  const fetchActivities = async () => {
    try {
      const res = await api.get("/activities");
      if (res?.data?.data) {
        setActivities(res.data.data);
        setFiltered(res.data.data);
        const temp = {};
        res.data.data.forEach(
          (a) => (temp[a.id] = Math.floor(Math.random() * 2) + 4) // random 4–5 star demo
        );
        setRatings(temp);
      }
    } catch (err) {
      console.error("Error fetching activities", err);
    }
  };

  useEffect(() => {
    let data = [...activities];

    // 🔍 Search
    if (search) {
      data = data.filter(
        (a) =>
          a.name.toLowerCase().includes(search.toLowerCase()) ||
          a.destinations.some((d) =>
            d.destination_name.toLowerCase().includes(search.toLowerCase())
          )
      );
    }

    // 💰 Price filter
    data = data.filter((a) =>
      a.destinations.some(
        (d) => d.price >= priceRange[0] && d.price <= priceRange[1]
      )
    );

    // 🔄 Sorting
    if (sortBy === "low-high") {
      data.sort(
        (a, b) =>
          Math.min(...a.destinations.map((d) => d.price)) -
          Math.min(...b.destinations.map((d) => d.price))
      );
    } else if (sortBy === "high-low") {
      data.sort(
        (a, b) =>
          Math.max(...b.destinations.map((d) => d.price)) -
          Math.max(...a.destinations.map((d) => d.price))
      );
    } else if (sortBy === "rating") {
      data.sort((a, b) => ratings[b.id] - ratings[a.id]);
    }

    setFiltered(data);
  }, [search, priceRange, sortBy, activities]);

  const sanitizeHTML = (html) => ({
    __html: DOMPurify.sanitize(html),
  });

  return (
    <div style={{ minHeight: "80vh" }}>
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>
      {/* style={{ background: `url(${require("../Images/weekendtour.jpg")}) center/cover no-repeat` }} */}


      <div class="filter-section">
        <div class="filter-container">
          {/* <!-- 🔍 Search --> */}
          <div class="filter-box">
            <input
              type="text"
              class="filter-input"
              placeholder="Search by name or destination"
              value={search}
              onChange={(e) => setSearch(e.target.value)}

            />
          </div>

          {/* <!-- 🔽 Sort By --> */}
          <div class="filter-box">
            <select class="filter-select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
              <option value="">Sort By</option>
              <option value="low-high">💸 Price: Low → High</option>
              <option value="high-low">💰 Price: High → Low</option>
              <option value="rating">⭐ Rating</option>
            </select>
          </div>
        </div>
      </div>




      {/* ---- Activity Cards ---- */}
      <Container sx={{ py: 5 }}>
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          {filtered.length > 0 ? (
            filtered.map((activity) => {
              const minPrice = Math.min(
                ...activity.destinations.map((d) => d.price)
              );
              const ratingValue = ratings[activity.id] || 4;

              return (
                <Grid item xs={12} sm={6} md={4} lg={3} key={activity.id} >
                  <Card
                    sx={{
                      height: "100%",
                      maxWidth: 250,
                      borderRadius: 3,
                      boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
                      },
                      justifyContent: "center"
                    }}
                    onClick={() => navigate(`/activity/${activity.id}`)}
                  >
                    <CardMedia
                      component="img"
                      height="180"
                      image={activity.image}
                      alt={activity.name}
                      sx={{ objectFit: "cover" }}
                    />
                    <CardContent>
                      <Typography
                        variant="h6"
                        gutterBottom
                        noWrap
                        color="primary"
                      >
                        {activity.name}
                      </Typography>

                      <Box
                        dangerouslySetInnerHTML={sanitizeHTML(
                          activity.description
                        )}
                        sx={{
                          fontSize: "0.85rem",
                          color: "text.secondary",
                          height: 20,
                          overflow: "hidden",
                          mb: 1,
                        }}
                      />

                      <Typography variant="body2" color="text.secondary">
                        Destination:{" "}
                        {activity.destinations
                          .map((d) => d.destination_name)
                          .join(", ")}
                      </Typography>

                      <Typography
                        variant="h6"
                        sx={{ mt: 1, color: "#1976d2", fontWeight: "bold" }}
                      >
                        ₹{minPrice.toLocaleString()}
                      </Typography>

                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ mt: 1 }}
                      >
                        <Rating
                          name={`rating-${activity.id}`}
                          value={ratingValue}
                          readOnly
                          precision={0.5}
                        />
                        <Typography variant="body2" color="text.secondary">
                          {ratingValue.toFixed(1)}
                        </Typography>
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })
          ) : (
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{ textAlign: "center", width: "100%", mt: 4 }}
            >
              No activities found.
            </Typography>
          )}
        </Grid>
      </Container>
    </div>
  );
};

export default ActivityGrid;
